import { render } from "./StoragePage.vue?vue&type=template&id=4e18e3e0"
import script from "./StoragePage.vue?vue&type=script&lang=js"
export * from "./StoragePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__